import { connect } from 'react-redux'
import DriversPane from '../../components/drivers/DriversPane'
import { fetchProductsByOrganizationId } from '../../state/actions/provider-products'
import { IStoreState } from '../../types'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    organizationId: state.organizations.currentOrgId,
    routeProps: ownProps
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onComponentMount: (organizationId: string) => {
      // dispatch(fetchAllProvidersWithActiveProducts())
      const dto = {
        organizationId,
        skip: 0,
        take: 9999, // get all existing products
        active: true
      }
      dispatch(fetchProductsByOrganizationId(dto))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriversPane)



// WEBPACK FOOTER //
// ./src/containers/drivers/DriversPane.ts